import React from "react";
import { faPrint } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Stack, Tooltip } from "@mui/material"
import { exportColor, iconSize } from "../App/GridRenderers"

export const PrintPage = ({ onPrint, tooltip }) => {
    return (
        <Stack sx={{ px: 2, pt: 2 }}>

            <Tooltip
                title={tooltip}
                enterDelay={1000}>
                <FontAwesomeIcon
                    icon={faPrint}
                    color={exportColor}
                    size={iconSize}
                    onClick={onPrint}
                />
            </Tooltip>
        </Stack >
    )
}